<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()" *ngIf="!currentUrl">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{(getNomenclatura(tipoEvento) | nomenclatura | async)}}</ion-title>

    <ion-col class="end-filter" *ngIf="!categorias">
      <i class="fa-solid fa-filter" id="modalFiltro" style="font-size: 18px !important"></i>
    </ion-col>
  </ion-buttons>
</ion-header>

<ion-content *ngIf="!loaded">
  <app-loading-spinner></app-loading-spinner>
</ion-content>

<ion-content *ngIf="loaded">
  <div class="gradient-extendido">
    <ion-segment mode="ios" value="programacao" (ionChange)="segmentChanged($event)" class="segment-gradient-title">
      <ion-segment-button value="programacao">
        <ion-label class="header">{{'Agenda' | translate}}</ion-label>
      </ion-segment-button>

      <ion-segment-button value="inscrito">
        <ion-label class="header"> {{'Inscrito' | translate}}</ion-label>
      </ion-segment-button>
    </ion-segment>
  </div>

  <ion-grid>
    <ion-row>
      <ion-col size="12">
        <ion-searchbar
          show-cancel-button="never"
          class="custom"
          [placeholder]="('Buscar' | translate)"
          [(ngModel)]="searchTerm"
          (ionInput)="onInput($event)"
          mode="ios"
        >
        </ion-searchbar>
      </ion-col>
    </ion-row>
  </ion-grid>

  <div [ngSwitch]="eventoTipo">
    <div *ngSwitchCase="'programacao'">
      <div *ngFor="let evento of eventosFiltrados">
        <div class="date-event">
          <ion-card-header *ngIf="evento.eventos.length">
            <div class="data-evento-mes">
              <i class="far fa-calendar icon-card"></i>

              <p class="mes-evento">
                {{evento.data | dateFormat:'MMMM'}} <span>{{'de' | translate}}</span>
                {{evento.data | dateFormat:'yyyy'}}
              </p>
            </div>
          </ion-card-header>
        </div>

        <div *ngIf="evento.eventos.length">
          <ion-card
            *ngFor="let eventoTema of evento.eventos"
            class="event-card ion-activatable"
            (click)="selecionarEvento(eventoTema.id);"
            button
          >
            <ion-ripple-effect></ion-ripple-effect>

            <div class="banner-container">
              <img class="banner-image" [src]="eventoTema.imagem | image:'evento'" />

              <ion-row class="row-chips" *ngIf="eventoTema.hide_date == 0">
                <ion-col size="12">
                  <ion-chip class="chip-overlay">
                    <ion-icon name="calendar-outline"></ion-icon>

                    <p class="instituicao-nome">{{ eventoTema.dataInicio | dateFormat: "curta" }}</p>
                  </ion-chip>
                </ion-col>
              </ion-row>
            </div>

            <ion-card-content>
              <h3 class="event-title">{{eventoTema.tema}}</h3>

              <div class="event-info">
                <div class="info-row">
                  <div class="info-icon">
                    <i class="fa-duotone fa-regular fa-clock"></i>
                  </div>

                  <span>
                    {{eventoTema.dataInicio | dateFormat:'hora'}} - {{eventoTema.dataFim | dateFormat:'hora'}}
                  </span>
                </div>
              </div>

              <ion-button class="event-button btn-default">
                <span>{{'Ver detalhes' | translate}}</span>
                <ion-icon name="chevron-forward-outline"></ion-icon>
              </ion-button>
            </ion-card-content>
          </ion-card>
        </div>
      </div>
      <sem-registro *ngIf="eventos.length == 0 || eventosFiltrados.length == 0"></sem-registro>
    </div>

    <div *ngSwitchCase="'inscrito'">
      <div *ngFor="let eventoInsc of eventosInscFiltrados">
        <div class="date-event">
          <ion-card-header >
            <div class="data-evento-mes">
              <i class="far fa-calendar icon-card"></i>
               <p class="mes-evento">
                {{eventoInsc.data | dateFormat:'MMMM'}} <span>{{'de' | translate}}</span>
                {{eventoInsc.data | dateFormat:'yyyy'}}
              </p>
            </div>
          </ion-card-header>
        </div>

        <div *ngIf="eventosInscrito.length > 0">
          <ion-card
            *ngFor="let inscrito of eventoInsc.eventos"
            class="event-card ion-activatable"
            (click)="selecionarEvento(inscrito.id);"
            button
          >
            <ion-ripple-effect></ion-ripple-effect>

            <div class="banner-container">
              <img class="banner-image" [src]="inscrito.imagem | image:'evento'" />

              <ion-row class="row-chips">
                <ion-col size="12">
                  <ion-chip class="chip-overlay">
                    <ion-icon name="calendar-outline"></ion-icon>

                    <p class="instituicao-nome">{{ inscrito.dataInicio | dateFormat: "curta" }}</p>
                  </ion-chip>
                </ion-col>
              </ion-row>
            </div>

            <ion-card-content>
              <h3 class="event-title">{{inscrito.tema}}</h3>

              <div class="event-info" *ngIf="inscrito.hide_date == 0">
                <div class="info-row">
                  <div class="info-icon">
                    <i class="fa-duotone fa-regular fa-clock"></i>
                  </div>

                  <span> {{inscrito.dataInicio | dateFormat:'hora'}} - {{inscrito.dataFim | dateFormat:'hora'}} </span>
                </div>
              </div>

              <ion-button class="event-button btn-default">
                <span>{{'Ver Detalhes' | translate}}</span>
                <ion-icon name="chevron-forward-outline"></ion-icon>
              </ion-button>
            </ion-card-content>
          </ion-card>
        </div>
      </div>

      <sem-registro *ngIf="eventosInscrito.length == 0 || eventosInscFiltrados.length == 0"></sem-registro>
    </div>
  </div>

  <ion-modal #modalFilter trigger="modalFiltro">
    <ng-template>
      <ion-header class="extendido">
        <ion-buttons>
          <ion-button (click)="modalFilter.dismiss()">
            <i class="fa-regular fa-chevron-left chevron-back-button"></i>
          </ion-button>

          <ion-title>{{'Filtrar' | translate}}</ion-title>
        </ion-buttons>
      </ion-header>

      <ion-content class="ion-padding">
        <form [formGroup]="form">
          <div style="padding-right: 8px" *ngIf="eventoTipo == 'inscrito'">
            <prover-datepicker [labelName]="'Data Início'" [id]="'dataInicio'" formControlName="dataInicio"></prover-datepicker>
          </div>

          <div style="padding-right: 8px" *ngIf="eventoTipo == 'inscrito'">
            <prover-datepicker [labelName]="'Data Fim'" [id]="'dataFim'" formControlName="dataFim"></prover-datepicker>
          </div>

          <ion-row class="prover-datepicker" *ngIf="!categorias">
            <ion-col size="12" class="remove-border">
              <ion-item>
                <ion-select
                  formControlName="tipoSelecionado"
                  name="tipoEvento"
                  labelPlacement="stacked"
                  interface="action-sheet"
                  placeholder="{{'Tipo' | translate}}"
                  cancelText="{{ 'Cancelar' | translate}}"
                  okText="{{ 'Confirmar' | translate}}"
                >
                  <div slot="label">{{'Tipo' | translate}}</div>
                  <ion-select-option [value]="0">{{'Todos' | translate}}</ion-select-option>
                  <ion-select-option *ngFor="let tipos of tiposEventos" [value]="tipos.id">
                    {{tipos.nome}}
                  </ion-select-option>
                </ion-select>
              </ion-item>
            </ion-col>
          </ion-row>

          <div class="down">
            <ion-button class="btn-default" expand="block" (click)="filter()"> {{'Filtrar' | translate }} </ion-button>
          </div>
        </form>
      </ion-content>
    </ng-template>
  </ion-modal>
</ion-content>
